import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 * 获取产品参数列表
 *
 */
const getAllParams = async () => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/product-params`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取远方动力产品参数列表
 *
 */
const getAllParamsRemote = async () => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/repower/v2/product-params`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取产品参数列表
 *
 */
const getAllSystemParams = async () => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v1/sys-params/get-my-system-param`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
const strategy = {
  getAllParams,
  getAllSystemParams,
  getAllParamsRemote
}
export default strategy
